export const SWAP = ['ICONS', 'SPRT', 'MOXY']
